module.exports = __webpack_public_path__ + "img/drive-vil-4.d97a9ddc.svg";